import { rgba } from 'polished'
import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Illustration = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 120px;
`

export const InfoCard = styled.div`
  padding: 8px;
  background-color: ${({ theme }) => theme.ds.colors.infoBackground};
  border: 1px solid ${({ theme }) => rgba(theme.ds.colors.infoBorder, 0.3)};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`
